var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-page page"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "index-main page-main"
  }, [_c('div', {
    staticClass: "index-tab"
  }, [_c('div', {
    staticClass: "index-tab__title"
  }, [_c('div', {
    staticClass: "index-tab__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.svg_fire)
    }
  }), _vm._v(" CHOOSE TO EARN ")]), _c('m-tab', {
    attrs: {
      "tab": _vm.tabList,
      "selectTab": _vm.selectTab
    },
    on: {
      "update:selectTab": function ($event) {
        _vm.selectTab = $event;
      },
      "update:select-tab": function ($event) {
        _vm.selectTab = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "index-list"
  }, [_vm.selectTab && _vm.selectTab.value === 0 ? [_vm.activityList ? [_vm.activityList.length > 0 ? _vm._l(_vm.activityList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-item",
      class: item.background && 'bg',
      on: {
        "click": function ($event) {
          return _vm.showPop(item);
        }
      }
    }, [_c('div', {
      staticClass: "index-item-body"
    }, [_c('div', {
      staticClass: "index-item-main"
    }, [item.background ? _c('div', {
      staticClass: "index-item-bg",
      style: {
        background: item.background && `url(${item.background}) center top/100% auto no-repeat`
      }
    }) : _vm._e(), _c('div', {
      staticClass: "index-head",
      class: [JSON.stringify(item.user_prediction_dto) != '{}' && 'isChoice', item.status === 2 && 'payout']
    }, [_c('div', {
      staticClass: "index-status"
    }, [item.status === 1 && JSON.stringify(item.user_prediction_dto) == '{}' ? [_c('div', {
      staticClass: "index-tag"
    }, [_vm._v("Open")]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : item.status === 1 && JSON.stringify(item.user_prediction_dto) != '{}' && item.is_over == 0 ? [_c('div', {
      staticClass: "index-tag chioce"
    }, [_vm._v("Choice:" + _vm._s(item.user_prediction_dto?.choice === 1 ? "Yes" : "No"))]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : item.status === 1 && JSON.stringify(item.user_prediction_dto) != '{}' && item.is_over == 1 ? [_c('div', {
      staticClass: "index-tag chioce"
    }, [_vm._v("Validation")]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : item.status === 2 && JSON.stringify(item.user_prediction_dto) != '{}' ? [_c('div', {
      staticClass: "index-tag collect"
    }, [_vm._v("Collect Payout")]), _c('div', {
      staticClass: "index-tag",
      class: item.user_prediction_dto?.is_win === 1 ? 'win' : ''
    }, [_vm._v(_vm._s(item.user_prediction_dto?.is_win === 1 ? "Win" : "Lose"))]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : _vm._e()], 2), item.status === 1 && JSON.stringify(item.user_prediction_dto) == '{}' ? _c('div', {
      staticClass: "index-total"
    }, [_c('div', {
      staticClass: "index-tickets"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.ticket_cost)))]), _c('div', {
      staticClass: "index-change"
    }, [_vm._v(" Chance "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_change)
      }
    }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.fmt_pre(item.participants_count_1 / (item.participants_count_0 + item.participants_count_1) * 100, 2, true, true, 3)) + "%")])])]) : _vm._e()]), _c('div', {
      staticClass: "index-info"
    }, [_c('div', {
      staticClass: "index__img"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "index__intro",
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\*(.*?)\*/g, `<em style='color:#fed629'>$1</em>`))
      }
    })])]), _c('div', {
      staticClass: "index-bottom"
    }, [item.status === 1 ? [item.is_over == 0 ? _c('div', {
      staticClass: "index-bottom-info"
    }, [item.partnerInfo.name ? _c('div', {
      staticClass: "index-event"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_gift)
      }
    }), _vm._v(" " + _vm._s(item.partnerInfo.name))]) : _vm._e(), _c('div', {
      staticClass: "index-event"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_time)
      }
    }), _vm._v("Ends · " + _vm._s(_vm.fmt_time(item.end_time).format("MMM DD HH:mm ")))])]) : item.is_over == 1 ? _c('div', {
      staticClass: "index-bottom-info"
    }, [_c('div', {
      staticClass: "index-event waiting"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-time"
      }
    }), _vm._v("Waiting for result")], 1)]) : _vm._e(), _c('div', {
      staticClass: "btn-share",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onShareShow(item);
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-share"
      }
    })], 1)] : item.status === 2 && JSON.stringify(item.user_prediction_dto) != '{}' ? [_c('div', {
      staticClass: "index-bottom-info"
    }, [_c('div', {
      staticClass: "index-event"
    }, [_vm._v("Payout • "), item.user_prediction_dto?.reward_coin > 0 ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-coin.png'),
        "alt": ""
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.user_prediction_dto?.reward_coin)) + " ")] : _vm._e(), item.user_prediction_dto?.reward_ticket ? [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.user_prediction_dto?.reward_ticket)) + " ")] : _vm._e()], 2)])] : _vm._e(), item.partnerInfo.buttonUrl && _vm.isVailYoutube(item.partnerInfo.buttonUrl) ? _c('div', {
      staticClass: "btn-youtube",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onYoutube(item);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('@images/youtube.png'),
        "alt": ""
      }
    })]) : _vm._e()], 2)])]);
  }) : [_c('div', {
    staticClass: "index__empty"
  }, [_vm._v("There's nothing here")])]] : [_vm._m(0)]] : _vm.selectTab && _vm.selectTab.value === 1 ? [_vm.payoutList ? [_vm.payoutList.length ? _vm._l(_vm.payoutList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-item payout",
      class: item.background && 'bg',
      on: {
        "click": function ($event) {
          return _vm.showPopCollectPayoutShow(item);
        }
      }
    }, [_c('div', {
      staticClass: "index-item-body"
    }, [_c('div', {
      staticClass: "index-item-main"
    }, [item.background ? _c('div', {
      staticClass: "index-item-bg",
      style: {
        background: item.background && `url(${item.background}) center top/100% auto no-repeat`
      }
    }) : _vm._e(), _c('div', {
      staticClass: "index-head payout"
    }, [_c('div', {
      staticClass: "index-status"
    }, [item.status === 0 ? [_c('div', {
      staticClass: "index-tag collect"
    }, [_vm._v("Collect Payout")]), _c('div', {
      staticClass: "index-tag",
      class: item?.is_win === 1 ? 'win' : ''
    }, [_vm._v(_vm._s(item?.is_win === 1 ? "Win" : "Lose"))])] : _vm._e()], 2), _c('div', {
      staticClass: "index-total"
    }, [_c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)])]), _c('div', {
      staticClass: "index-info"
    }, [_c('div', {
      staticClass: "index__img"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "index__intro",
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\*(.*?)\*/g, `<em style='color:#fed629'>$1</em>`))
      }
    })])]), _c('div', {
      staticClass: "index-bottom"
    }, [item.status === 0 ? [_c('div', {
      staticClass: "index-bottom-info"
    }, [_c('div', {
      staticClass: "index-event"
    }, [_vm._v("Payout • "), item.reward_coin > 0 ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-coin.png'),
        "alt": ""
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.reward_coin)) + " ")] : _vm._e(), item.reward_ticket ? [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.reward_ticket)) + " ")] : _vm._e()], 2)])] : _vm._e()], 2)])]);
  }) : [_c('div', {
    staticClass: "index__empty"
  }, [_vm._v("There's nothing here")])]] : [_c('div', {
    staticClass: "circleLoding"
  })]] : _vm.selectTab && _vm.selectTab.value === 2 ? [_vm.historyList ? [_vm.historyList.length ? _vm._l(_vm.historyList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-item",
      class: item.background && 'bg',
      on: {
        "click": function ($event) {
          return _vm.showPop(item);
        }
      }
    }, [_c('div', {
      staticClass: "index-item-body"
    }, [_c('div', {
      staticClass: "index-item-main"
    }, [item.background ? _c('div', {
      staticClass: "index-item-bg",
      style: {
        background: item.background && `url(${item.background}) center top/100% auto no-repeat`
      }
    }) : _vm._e(), _c('div', {
      staticClass: "index-head",
      class: [JSON.stringify(item.user_prediction_dto) != '{}' && 'isChoice', item.status === 2 && 'payout']
    }, [_c('div', {
      staticClass: "index-status"
    }, [item.status === 1 && JSON.stringify(item.user_prediction_dto) == '{}' ? [_c('div', {
      staticClass: "index-tag"
    }, [_vm._v("Open")]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : item.status === 1 && JSON.stringify(item.user_prediction_dto) != '{}' && item.is_over == 0 ? [_c('div', {
      staticClass: "index-tag chioce"
    }, [_vm._v("Choice:" + _vm._s(item.user_prediction_dto?.choice === 1 ? "Yes" : "No"))]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : item.status === 1 && JSON.stringify(item.user_prediction_dto) != '{}' && item.is_over == 1 ? [_c('div', {
      staticClass: "index-tag chioce"
    }, [_vm._v("Validation")]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : item.status === 2 && JSON.stringify(item.user_prediction_dto) != '{}' ? [_c('div', {
      staticClass: "index-tag collect"
    }, [_vm._v("Collect Payout")]), _c('div', {
      staticClass: "index-tag",
      class: item.user_prediction_dto?.is_win === 1 ? 'win' : ''
    }, [_vm._v(_vm._s(item.user_prediction_dto?.is_win === 1 ? "Win" : "Lose"))]), _c('div', {
      staticClass: "index-per"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.participants_count_0 + item.participants_count_1, 2, false, false)))], 1)] : _vm._e()], 2), item.status === 1 && JSON.stringify(item.user_prediction_dto) == '{}' ? _c('div', {
      staticClass: "index-total"
    }, [_c('div', {
      staticClass: "index-tickets"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.ticket_cost)))]), _c('div', {
      staticClass: "index-change"
    }, [_vm._v(" Chance "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_change)
      }
    }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.fmt_pre(item.participants_count_1 / (item.participants_count_0 + item.participants_count_1) * 100, 2, true, true, 3)) + "%")])])]) : _vm._e()]), _c('div', {
      staticClass: "index-info"
    }, [_c('div', {
      staticClass: "index__img"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "index__intro",
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/\*(.*?)\*/g, `<em style='color:#fed629'>$1</em>`))
      }
    })])]), _c('div', {
      staticClass: "index-bottom"
    }, [item.status === 1 ? [item.is_over == 0 ? _c('div', {
      staticClass: "index-bottom-info"
    }, [item.partnerInfo.name ? _c('div', {
      staticClass: "index-event"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_gift)
      }
    }), _vm._v(" " + _vm._s(item.partnerInfo.name))]) : _vm._e(), _c('div', {
      staticClass: "index-event"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_time)
      }
    }), _vm._v("Ends · " + _vm._s(_vm.fmt_time(item.end_time).format("MMM DD HH:mm ")))])]) : item.is_over == 1 ? _c('div', {
      staticClass: "index-bottom-info"
    }, [_c('div', {
      staticClass: "index-event waiting"
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-time"
      }
    }), _vm._v("Waiting for result")], 1)]) : _vm._e(), _c('div', {
      staticClass: "btn-share",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onShareShow(item);
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "icon-share"
      }
    })], 1)] : item.status === 2 && JSON.stringify(item.user_prediction_dto) != '{}' ? [_c('div', {
      staticClass: "index-bottom-info"
    }, [_c('div', {
      staticClass: "index-event"
    }, [_vm._v("Payout • "), item.user_prediction_dto?.reward_coin > 0 ? [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-coin.png'),
        "alt": ""
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.user_prediction_dto?.reward_coin)) + " ")] : _vm._e(), item.user_prediction_dto?.reward_ticket ? [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v("+" + _vm._s(_vm.fmt_pre(item.user_prediction_dto?.reward_ticket)) + " ")] : _vm._e()], 2)])] : _vm._e(), item.partnerInfo.buttonUrl && _vm.isVailYoutube(item.partnerInfo.buttonUrl) ? _c('div', {
      staticClass: "btn-youtube",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.onYoutube(item);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('@images/youtube.png'),
        "alt": ""
      }
    })]) : _vm._e()], 2)])]);
  }) : [_c('div', {
    staticClass: "index__empty"
  }, [_vm._v("There's nothing here")])]] : [_c('div', {
    staticClass: "circleLoding"
  })]] : _vm._e()], 2)]), _c('m-menu'), _c('pop-prompt', {
    attrs: {
      "location": "bottom",
      "show": _vm.popConfirmChoiceShow,
      "title": "Confirm Your Choice",
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popConfirmChoiceShow = $event;
      }
    }
  }, [_vm.selectRow ? _c('div', {
    staticClass: "pop-confirmChoice"
  }, [_c('div', {
    staticClass: "pop-confirmChoice__img"
  }, [_vm.selectRow.isUserChoice === 1 ? _c('img', {
    attrs: {
      "src": require('@images/yes-img.png'),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require('@images/no-img.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-confirmChoice__cost"
  }, [_vm._v("Cost:  " + _vm._s(_vm.fmt_pre(_vm.selectRow.ticket_cost)) + " "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_tickets)
    }
  })]), _c('div', {
    staticClass: "pop-confirmChoice__info"
  }, [_vm._v(" You'll receive " + _vm._s(_vm.fmt_pre(_vm.selectRow.instant_reward)) + " SEES immediately for making"), _c('br'), _vm._v(" your choice ")]), _c('div', {
    staticClass: "pop-confirmChoice-btns",
    on: {
      "click": function ($event) {
        !_vm.submitLoading && _vm.onConfirmChoice();
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-confirm"
  }, [!_vm.submitLoading ? [_vm._v(" Confirm '" + _vm._s(_vm.selectRow.isUserChoice === 1 ? `Yes` : `No`) + "' ")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "location": "bottom",
      "isShare": true,
      "show": _vm.popMarkeChoiceShow,
      "title": _vm.selectRow && _vm.selectRow.isUserTicket ? 'Choice Locked In' : 'Make Your Choice',
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popMarkeChoiceShow = $event;
      },
      "share": function ($event) {
        return _vm.onShareShow(_vm.selectRow);
      }
    }
  }, [_vm.selectRow ? _c('div', {
    staticClass: "pop-markeChoice"
  }, [_c('div', {
    staticClass: "pop-markeChoice__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.selectRow.icon,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-markeChoice__title",
    domProps: {
      "innerHTML": _vm._s(_vm.selectRow.title.replace(/\*(.*?)\*/g, `<em style='color:#fed629'>$1</em>`))
    }
  }), _c('div', {
    staticClass: "pop-markeChoice-info"
  }, [_c('div', {
    staticClass: "pop-markeChoice-info-item"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-per"
    }
  }), _vm._v(_vm._s(_vm.fmt_pre(_vm.selectRow.participants_count_0 + _vm.selectRow.participants_count_1, 2, false, false)))], 1), _vm.selectRow.partnerInfo.name ? _c('div', {
    staticClass: "pop-markeChoice-info-item"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_gift)
    }
  }), _vm._v(" " + _vm._s(_vm.selectRow.partnerInfo.name))]) : _vm._e(), _c('div', {
    staticClass: "pop-markeChoice-info-item"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_twostar)
    }
  }), _vm._v("Ends · " + _vm._s(_vm.fmt_time(new Date(_vm.selectRow.end_time).getTime()).format("MMM DD HH:mm ")))])]), _c('div', {
    staticClass: "pop-markeChoice-total"
  }, [_c('div', {
    staticClass: "pop-markeChoice-total-item"
  }, [_vm._v(" If ‘Yes’ is correct "), _c('div', {
    staticClass: "pop-markeChoice-total-item__value"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.selectMultiplier.multiple * _vm.selectRow.possibleDecisions[0].payoutAmount)) + " "), _c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "pop-markeChoice-total-item"
  }, [_c('div', {
    staticClass: "pop-markeChoice-total-item__label"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_change)
    }
  }), _vm._v("Chance")]), _c('div', {
    staticClass: "pop-markeChoice-total-item__value"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.selectRow.participants_count_1 / (_vm.selectRow.participants_count_0 + _vm.selectRow.participants_count_1) * 100, 2, true, true, 3)) + "%")])]), _c('div', {
    staticClass: "pop-markeChoice-total-item"
  }, [_vm._v(" If ‘No’ is correct "), _c('div', {
    staticClass: "pop-markeChoice-total-item__value"
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.selectMultiplier.multiple * _vm.selectRow.possibleDecisions[1].payoutAmount)) + " "), _c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "pop-markeChoice__info"
  }, [_vm._v("You'll receive +" + _vm._s(_vm.fmt_pre(_vm.selectMultiplier.multiple * _vm.selectRow.instant_reward)) + " SEES just for participating")]), _c('div', {
    staticClass: "pop-markeChoice-multiplier"
  }, [_c('div', {
    staticClass: "pop-markeChoice-multiplier__title"
  }, [_vm._v("REWARD MULTIPLIER")]), _c('div', {
    staticClass: "pop-markeChoice-silder",
    class: _vm.selectRow.isUserTicket && 'selected'
  }, [_c('m-slide', {
    attrs: {
      "step": _vm.selectRow.multiplierInfo,
      "defaultValue": !_vm.selectRow.isUserTicket ? _vm.selectRow.default_multiple_index : _vm.selectRow.multiplierInfo.findIndex(itm => itm.multiple == _vm.selectRow.user_prediction_dto?.multiple)
    },
    on: {
      "selectFn": _vm.onSliderSelect
    }
  })], 1), _c('div', {
    staticClass: "pop-markeChoice-multiplier__info"
  }, [!_vm.selectRow.isUserTicket ? [_vm._v(" You can continue without betting by clicking YES or NO, or select the number of Stars you want to use as a bid multiplier for this answer ")] : _vm.multipleSelected ? [_vm._v("Your bet has been accepted. Your payout will be x" + _vm._s(_vm.multipleSelected <= 1 ? 2 : _vm.multipleSelected) + " of the reward amount")] : _vm._e()], 2)]), _vm.selectRow.conditions ? _c('div', {
    staticClass: "pop-markeChoice-condition"
  }, [_c('div', {
    staticClass: "pop-markeChoice-condition__title"
  }, [_vm._v("Condition")]), _c('div', {
    staticClass: "pop-markeChoice-condition__info",
    domProps: {
      "innerHTML": _vm._s(_vm.linkifyForTelegramSafe(_vm.selectRow.conditions).replace(/\*(.*?)\*/g, `<em style='color:#fed629'>$1</em>`))
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "pop-markeChoice-condition__cost"
  }, [_c('div', {
    staticClass: "pop-markeChoice-condition__cost_x"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_tickets)
    }
  }), _vm._v(" Each vote costs " + _vm._s(_vm.fmt_pre(_vm.selectRow.ticket_cost)) + " ticket. ")])]), _c('div', {
    staticClass: "pop-markeChoice-btns"
  }, [!_vm.selectRow.isUserTicket ? [_vm.selectRow.showChoiceBtn ? [!_vm.choiceLoading ? [_c('div', {
    staticClass: "btn btn-yes",
    on: {
      "click": function ($event) {
        return _vm.popMarkeChoiceConfirm(1);
      }
    }
  }, [_vm._v("Yes")]), _c('div', {
    staticClass: "btn btn-no",
    on: {
      "click": function ($event) {
        return _vm.popMarkeChoiceConfirm(0);
      }
    }
  }, [_vm._v("No")])] : _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])] : _vm._e()] : [_c('div', {
    staticClass: "btn btn-choiced"
  }, [_vm._v("Choice '" + _vm._s(_vm.selectRow?.user_prediction_dto?.choice === 1 ? `Yes` : `No`) + "'")])]], 2)]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "location": "bottom",
      "show": _vm.popPartnerInfoShow,
      "title": "",
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popPartnerInfoShow = $event;
      }
    }
  }, [_vm.selectRow ? _c('div', {
    staticClass: "pop-partnerinfo"
  }, [_c('div', {
    staticClass: "pop-partnerinfo__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.selectRow.partnerInfo.icon || _vm.selectRow.icon,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-partnerinfo__title"
  }, [_vm._v(_vm._s(_vm.selectRow.partnerInfo.title || _vm.selectRow.title))]), _c('div', {
    staticClass: "pop-partnerinfo__des",
    domProps: {
      "innerHTML": _vm._s(_vm.linkifyForTelegramSafe(_vm.selectRow.partnerInfo.description).replace(/\*(.*?)\*/g, `<em style='color:#fed629'>$1</em>`))
    }
  }), _c('div', {
    staticClass: "pop-partnerinfo-btns"
  }, [_c('div', {
    staticClass: "btn btn-confirm",
    on: {
      "click": _vm.onPartnerInfoVote
    }
  }, [_vm._v(_vm._s(_vm.selectRow.partnerInfo.buttonTitle || "Open"))]), _c('div', {
    staticClass: "btn btn-cancel",
    on: {
      "click": _vm.onPartnerInfoOpen
    }
  }, [_vm._v("Vote")])])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "location": "bottom",
      "show": _vm.popCollectPayoutShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html",
      "title": _vm.selectCollectPayoutRow && _vm.selectCollectPayoutRow.is_win ? 'You Got It Right' : 'You got it wrong'
    },
    on: {
      "update:show": function ($event) {
        _vm.popCollectPayoutShow = $event;
      }
    }
  }, [_vm.selectCollectPayoutRow ? _c('div', {
    staticClass: "pop-collectPayout"
  }, [_c('div', {
    staticClass: "pop-collectPayout__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.selectCollectPayoutRow.icon,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-collectPayout-reward"
  }, [_vm.selectCollectPayoutRow.reward_coin > 0 ? _c('em', [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  }), _vm._v("+" + _vm._s(_vm.fmt_pre(_vm.selectCollectPayoutRow.reward_coin)))]) : _vm._e(), _vm.selectCollectPayoutRow.reward_ticket > 0 ? _c('em', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_tickets)
    }
  }), _vm._v("+" + _vm._s(_vm.fmt_pre(_vm.selectCollectPayoutRow.reward_ticket)))]) : _vm._e()]), _c('div', {
    staticClass: "pop-collectPayout__des"
  }, [_vm._v("Your choice: '" + _vm._s(_vm.selectCollectPayoutRow.choice === 1 ? "Yes" : "No") + "'")]), _c('div', {
    staticClass: "pop-collectPayout-btns",
    on: {
      "click": _vm.popCollectPayoutConfirm
    }
  }, [_c('div', {
    staticClass: "btn btn-cancel"
  }, [!_vm.popCollectPayoutConfirmIsLoading ? [_vm._v("Collect Now")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "location": "bottom",
      "show": _vm.popIndexItemShareShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html",
      "title": "Earn Together"
    },
    on: {
      "update:show": function ($event) {
        _vm.popIndexItemShareShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-indexitemshare"
  }, [_c('div', {
    staticClass: "pop-indexitemshare-list"
  }, [_c('div', {
    staticClass: "pop-indexitemshare-item"
  }, [_c('div', {
    staticClass: "pop-indexitemshare__icon"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_tickets)
    }
  })]), _c('div', {
    staticClass: "pop-indexitemshare__title"
  }, [_vm._v("You receive "), _c('span', {
    staticStyle: {
      "color": "#ffc600"
    }
  }, [_vm._v("+" + _vm._s(_vm.fmt_pre(_vm.settingInfo.reward.eventReward.join.ticket)) + " Ticket")]), _vm._v(" whenyour friend claims first reward ")])]), _c('div', {
    staticClass: "pop-indexitemshare-item"
  }, [_c('div', {
    staticClass: "pop-indexitemshare__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-indexitemshare__title"
  }, [_vm._v(" You will receive "), _c('span', {
    staticStyle: {
      "color": "#ffc600"
    }
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.settingInfo.reward.eventReward.join.coin)) + " SEES")]), _vm._v(" every time your friends vote ")])]), _c('div', {
    staticClass: "pop-indexitemshare-item"
  }, [_c('div', {
    staticClass: "pop-indexitemshare__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-indexitemshare__title"
  }, [_vm._v("You receive "), _c('span', {
    staticStyle: {
      "color": "#ffc600"
    }
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.settingInfo.reward.eventReward.join.starsRate)) + "%")]), _vm._v(" of the stars paid by your friends. ")])])]), _c('div', {
    staticClass: "pop-indexitemshare-btns"
  }, [_c('div', {
    staticClass: "btn-share",
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("Invite")]), _c('div', {
    staticClass: "btn-copy",
    on: {
      "click": _vm.onCopy
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1)])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]);
}];
export { render, staticRenderFns };